import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import DateField from '../../components/DateField';
import { searchMyInvoices } from '../../api/companyBilling';
import './FacturationPage.css';

const money = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Facturation mensuelle (popover Compte / Parametres) — la company consulte
// SES PROPRES factures (billing/views.py:CompanyInvoiceListView), lecture
// seule (amount_paid reste modifie uniquement par le superadmin). Calendrier
// + recherche demandes explicitement : une date choisie cherche la facture
// dont la periode couvre cette date ; sans date, affiche tout l'historique.
const FacturationPage = () => {
  const [date, setDate] = useState('');
  const [invoices, setInvoices] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searched, setSearched] = useState(false);

  const load = (d) => {
    setLoading(true);
    setError('');
    searchMyInvoices(d)
      .then((data) => { setInvoices(data); setSearched(true); })
      .catch(() => setError('Recherche impossible.'))
      .finally(() => setLoading(false));
  };

  // Historique complet au premier affichage, avant toute recherche par date.
  useEffect(() => { load(''); }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    load(date);
  };

  const handleReset = () => {
    setDate('');
    load('');
  };

  return (
    <Layout>
      <p className="cp-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <span className="bc-current">Parametres</span>
        {' >> '}
        <span className="bc-current">Facturation mensuelle</span>
      </p>

      <div className="cp-card fp-card">
        <div className="cp-card-header">
          <span className="cp-card-title">Facturation mensuelle</span>
        </div>
        <div className="cp-card-body">
          <form className="fp-form" onSubmit={handleSearch}>
            <div className="cp-row">
              <label className="cp-label">Date</label>
              <DateField className="cp-input" value={date} onChange={setDate} />
            </div>
            <div className="fp-actions">
              <button type="submit" className="cp-save-btn" disabled={loading}>
                {loading ? 'Recherche...' : 'Rechercher'}
              </button>
              {date && (
                <button type="button" className="fp-reset-btn" onClick={handleReset}>
                  Voir tout l'historique
                </button>
              )}
            </div>
          </form>

          {error && <p className="cp-error">{error}</p>}

          {!loading && searched && (
            <div className="fp-table-wrap">
              <table className="fp-table">
                <thead>
                  <tr>
                    <th>Période</th>
                    <th>POS total</th>
                    <th>POS facturables</th>
                    <th>Montant période</th>
                    <th>Ancien solde reporté</th>
                    <th>Total à payer</th>
                    <th>Montant payé</th>
                    <th>Solde</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.length === 0 && (
                    <tr>
                      <td colSpan={8} className="fp-empty">
                        Aucune facture trouvée.
                      </td>
                    </tr>
                  )}
                  {invoices.map((inv) => {
                    const balance = Number(inv.balance || 0);
                    return (
                      <tr key={inv.id}>
                        <td>{inv.period_start} → {inv.period_end}</td>
                        <td className="fp-center">{inv.total_bank_count ?? 0}</td>
                        <td className="fp-center">{inv.billable_bank_count ?? 0}</td>
                        <td className="fp-money">{money(inv.amount_due)}</td>
                        <td className="fp-money">{money(inv.carried_balance)}</td>
                        <td className="fp-money">{money(inv.total_due)}</td>
                        <td className="fp-money">{money(inv.amount_paid)}</td>
                        <td className={`fp-money ${balance > 0 ? 'fp-balance-due' : 'fp-balance-clear'}`}>
                          {money(balance)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default FacturationPage;
